import { useNavigate } from "react-router-dom";

import { IonIcon } from "@ionic/react";
import { arrowBackOutline } from "ionicons/icons";

import DashboardLayout from "../../layouts/DashboardLayout/DashboardLayout";

import cards from "../../assets/img/cards.png";

const VirtualCard = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="virtual-card">
        <span className="virtual-card__back" onClick={() => navigate(-1)}>
          <IonIcon icon={arrowBackOutline} />
        </span>
        <img className="virtual-card__img" src={cards} alt="" />
        <div className="virtual-card__info">
          <h3 className="virtual-card__heading">COMING SOON...</h3>
          <p className="virtual-card__text">
            Spend worldwide with your sekiapp virtual card, hang on while we do
            the touch ups 😉
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default VirtualCard;
